//@ts-strict-ignore
import { IAlternativeProductsDropdownQueryResult, ISalesOrderLine } from '../../../graphql/schema/p4types';
import setIn from '../../connectedForm/utils/setIn';
import React from 'react';
import EditableDataGrid from '../../EditableDataGrid';
import { IEditableDataGridColumnDef } from '../../../@types/editableDataGridTypes';
import BooleanFormatter from '../../grid-addons/formatters/BooleanFormatter';

const ALTERNATIVE_PRODUCT_COLUMNS: Array<IEditableDataGridColumnDef> = [
  {
    name: 'Product',
    key: 'alternativeProduct.product.reference',
    editable: false,
    resizable: true,
  },
  {
    name: 'Description',
    key: 'alternativeProduct.product.description',
    editable: false,
    resizable: true,
  },
  {
    name: 'Reason',
    key: 'alternativeProduct.type',
    editable: false,
    resizable: true,
  },
  {
    name: 'Free Stock',
    key: 'freeStock',
    editable: false,
    resizable: true,
    width: 120,
  },
  {
    name: 'Preferred',
    key: 'alternativeProduct.preferred',
    formatter: BooleanFormatter,
    editable: false,
    resizable: true,
    width: 120,
  },
];

export const AlternativeProductsGrid = ({
  onRowClick: parentOnRowClick,
  onChange,
  value,
  alternativeProductData,
  ignoreKeypresses,
}: {
  onRowClick?: Function;
  onChange: Function;
  value?: ISalesOrderLine;
  alternativeProductData?: IAlternativeProductsDropdownQueryResult;
  ignoreKeypresses?: boolean;
}) => {
  const alternativeProducts = alternativeProductData?.list;
  if (!alternativeProducts || alternativeProducts.length === 0) {
    return <p style={{ marginTop: '10px' }}>No alternative products found for this Product.</p>;
  }

  const altMessage =
    alternativeProducts && alternativeProducts.length > 0
      ? 'Would you like to use one of the following alternatives?'
      : 'There are no alternative products with enough free stock to choose from.';

  const onRowClick = (index, rowData) => {
    // update current order line row with selected product
    let lineValue = value;
    lineValue = setIn(lineValue, 'product', rowData.alternativeProduct.product);
    lineValue = setIn(
      lineValue,
      'description',
      rowData.alternativeProduct.product.salesDescription
        ? rowData.alternativeProduct.product.salesDescription
        : rowData.alternativeProduct.product.description
    );
    onChange(lineValue);
    parentOnRowClick?.();
  };

  return (
    <>
      <p style={{ marginTop: '10px' }}>{altMessage}</p>
      <EditableDataGrid
        columns={ALTERNATIVE_PRODUCT_COLUMNS}
        listData={alternativeProducts}
        rowsCount={alternativeProducts.length}
        addBlankRow={false}
        onRowClick={onRowClick}
        contentHeight={200}
        ignoreKeypresses={ignoreKeypresses}
      />
    </>
  );
};
